import {NgModule} from '@angular/core';
import {OrderLinesGridService} from '@application/helper/orderbook/order-lines-grid.service';
import {ARTICLES} from '@infrastructure/http/article/articles';
import {HttpArticlesService} from '@infrastructure/http/article/http-articles.service';
import {COLOR_SETS} from '@infrastructure/http/color-set/color-sets';
import {HttpColorSetsService} from '@infrastructure/http/color-set/http-color-sets.service';
import {COLORS} from '@infrastructure/http/color/colors';
import {HttpColorsService} from '@infrastructure/http/color/http-colors.service';
import {COLORED_YARN_SETS} from '@infrastructure/http/colored-yarn-set/colored-yarn-sets';
import {HttpColoredYarnSetsService} from '@infrastructure/http/colored-yarn-set/http-colored-yarn-sets.service';
import {HttpMachineQualitiesService} from '@infrastructure/http/machine-quality/http-machine-qualities.service';
import {MACHINE_QUALITIES} from '@infrastructure/http/machine-quality/machine-qualities';
import {HttpOrderbookService} from '@infrastructure/http/orderbook/http-orderbook.service';
import {ORDERBOOK} from '@infrastructure/http/orderbook/orderbook';
import {DrawingLibrarySharedModule} from '@presentation/pages/texedit/drawing-library/drawing-library-shared.module';
import {orderbookDataRouting} from '@presentation/pages/texfab/orderbook/orderbook.routing';
import {SharedModule} from '@shared/shared.module';
import {AgGridModule} from 'ag-grid-angular';
import {OrderbookOverviewPageComponent} from './overview/orderbook-overview-page.component';
import {OrderlineDetailsSidebarComponent} from './overview/orderline-details-sidebar/orderline-details-sidebar.component';
import {OrderbookCustomSettingsComponent} from './settings/orderbook-custom-settings.component';

@NgModule({
  imports: [SharedModule, orderbookDataRouting, AgGridModule, DrawingLibrarySharedModule],
  providers: [
    {provide: ORDERBOOK, useClass: HttpOrderbookService},
    {provide: COLORED_YARN_SETS, useClass: HttpColoredYarnSetsService},
    {provide: MACHINE_QUALITIES, useClass: HttpMachineQualitiesService},
    {provide: COLOR_SETS, useClass: HttpColorSetsService},
    {provide: COLORS, useClass: HttpColorsService},
    {provide: ARTICLES, useClass: HttpArticlesService},
    OrderLinesGridService
  ],
  declarations: [OrderbookOverviewPageComponent, OrderlineDetailsSidebarComponent, OrderbookCustomSettingsComponent]
})
export class OrderbookModule {}
